// Reescreve URL Xtream upstream pra rota correta conforme o STREAM MODE da
// plataforma (resolveStreamMode em @app-iptv/shared).
//
// PREMISSA FUNDADORA: conteúdo NÃO passa pela nossa infra. O modo é decidido
// por CAPABILITY da plataforma (detectPlatform), NÃO por sniff de user-agent —
// assim qualquer stack nova (desktop .exe, Hisense/VIDAA, etc., mesmo source)
// vai DIRETO por padrão (default 'direct'), sem risco de vazar banda por engano.
//
// - mode 'direct' (TV/desktop/mobile nativo + qualquer plataforma futura):
//   toca o Xtream DIRETO. Player nativo lida com cert self-signed/HTTP/CORS.
// - mode 'proxy' (SÓ navegador: web/mobile-pwa): passa por /v1/proxy/stream.
//   Exceção TÉCNICA inevitável — página HTTPS não toca Xtream em IP+cert
//   self-signed (mixed content com IP = bloqueado sem workaround) nem via MSE
//   (sem CORS). Ver docs/scaling-playbook.md §4.
// - Browser dev: HLS m3u8 → /xtream-stream; TS/MP4 → /xtream-mp4 (Vite proxy).

import { detectPlatform } from '@app-iptv/device'
import { resolveStreamMode } from '@app-iptv/shared'

const DEMO_HLS = 'https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8'

export function rewriteStreamUrl(
  realUrl: string,
  format: 'hls' | 'mp4' | 'mpegts',
  // Assinatura HMAC do proxy (vem do /v1/stream/sign). Sem ela, o backend
  // rejeita com 403 (anti open-proxy). Só o modo 'proxy' (navegador) usa.
  sign?: { proxySig?: string | undefined; proxyExp?: number | undefined },
): string {
  if (import.meta.env['VITE_USE_DEMO_STREAM']) return DEMO_HLS
  // Capability-based: só navegador (web/mobile-pwa) proxia; resto vai direto.
  if (resolveStreamMode(detectPlatform()) === 'direct') return realUrl
  if (import.meta.env.DEV) {
    // HLS m3u8 → /xtream-stream (reescreve segments).
    // TS/MP4 → /xtream-mp4 (pipe binário direto).
    const prefix = format === 'hls' ? '/xtream-stream' : '/xtream-mp4'
    return `${prefix}?u=${encodeURIComponent(realUrl)}`
  }
  const apiBase = (import.meta.env['VITE_API_BASE_URL'] as string | undefined) ?? ''
  let out = `${apiBase}/v1/proxy/stream?u=${encodeURIComponent(realUrl)}`
  if (sign?.proxySig && sign.proxyExp != null) {
    out += `&exp=${sign.proxyExp}&sig=${encodeURIComponent(sign.proxySig)}`
  }
  return out
}
